import * as yup from "yup";
import { UserRoleEnum } from "../../graphql/graphql";
import { Max, Patterns, Validation } from "../../utils/Validation.utils";
export const TeamDrawerInitialValues = {
    role: UserRoleEnum.Provider,
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    imageKey: null,
    imageVersion: null,
    locationIds: [],
    daysAvailable: [],
    about: "",
    notes: "",
    educationAndCertifications: "",
    preferredAges: [],
    therapyCategoryId: null,
    therapySubCategoryIds: []
};
export const TeamDrawerSchema = yup.object().shape({
    role: yup
        .mixed()
        .oneOf(Object.values(UserRoleEnum))
        .required(Validation.Required),
    firstName: yup
        .string()
        .max(Max.FirstName, Validation.Max)
        .required(Validation.Required),
    lastName: yup
        .string()
        .max(Max.LastName, Validation.Max)
        .required(Validation.Required),
    email: yup.string().email(Validation.Invalid).required(Validation.Required),
    phoneNumber: yup
        .string()
        .matches(Patterns.PhoneNumber, Validation.Invalid)
        .max(Max.PhoneNumber, Validation.Max)
        .required(Validation.Required),
    imageKey: yup.string().nullable(),
    imageVersion: yup.string().nullable(),
    locationIds: yup.array().of(yup.string().required()),
    daysAvailable: yup.array().of(yup.string().required()),
    about: yup.string(),
    notes: yup.string(),
    educationAndCertifications: yup.string(),
    preferredAges: yup.array().of(yup.string().required()),
    therapyCategoryId: yup.string().nullable(),
    therapySubCategoryIds: yup.array().of(yup.string().required())
});
